"use client";

import React, { useEffect, useRef, useState } from "react";

export default function HomeChatComposer({ onSendMessage, isSending }) {
  const [value, setValue] = useState("");
  const textareaRef = useRef(null);

  const canSend = value.trim().length > 0 && !isSending;

  function submit(e) {
    e?.preventDefault?.();
    const trimmed = value.trim();
    if (!trimmed || isSending) return;
    onSendMessage(trimmed);
    setValue("");
  }

  function onKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit(e);
    }
  }

  // Auto-resize hasta 4 líneas, luego scroll
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    const styles = window.getComputedStyle(el);
    const lineHeight = parseFloat(styles.lineHeight) || 20;
    const paddingTop = parseFloat(styles.paddingTop) || 0;
    const paddingBottom = parseFloat(styles.paddingBottom) || 0;

    const maxHeight = lineHeight * 4 + paddingTop + paddingBottom;

    el.style.height = "auto";
    const nextHeight = Math.min(el.scrollHeight, maxHeight);
    el.style.height = `${nextHeight}px`;
    el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
  }, [value]);

  return (
    <div className="rbt-static-bar home-chat-form-message w-100">
      <form className="new-chat-form border-gradient" onSubmit={submit}>
        <textarea
          ref={textareaRef}
          rows={1}
          placeholder="Pregúntame sobre TutorIA+…"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={onKeyDown}
        />

        <div className="right-icons">
          <button
            className={`form-icon icon-send ${canSend ? "is-active" : ""}`}
            disabled={!canSend}
            aria-disabled={!canSend}
          >
            <i className="fa-solid fa-arrow-up"></i>
          </button>
        </div>
      </form>

      <p className="b3 small-text">
        Puede contener errores. Verifica lo importante.
      </p>
    </div>
  );
}
